var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_73704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_73704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9875 22C9.87917 22 8.02083 21.2603 6.4125 19.7808C4.80417 18.3013 4 16.2994 4 13.7751C4 12.2067 4.59167 10.5063 5.775 8.6738C6.95833 6.8413 8.75833 4.85838 11.175 2.72505C11.2843 2.62505 11.4117 2.55005 11.5574 2.50005C11.7031 2.45005 11.8488 2.42505 11.9945 2.42505C12.1401 2.42505 12.2858 2.45005 12.4315 2.50005C12.5772 2.55005 12.7083 2.62505 12.825 2.72505C15.225 4.85838 17.0208 6.8413 18.2125 8.6738C19.4042 10.5063 20 12.2067 20 13.7751C20 16.2994 19.1917 18.3013 17.575 19.7808C15.9583 21.2603 14.0958 22 11.9875 22ZM12 19.9C13.6667 19.9 15.0667 19.3292 16.2 18.1875C17.3333 17.0459 17.9 15.5735 17.9 13.7704C17.9 12.6066 17.4167 11.2747 16.45 9.77485C15.4833 8.27498 14 6.61672 12 4.80005C9.98333 6.61672 8.49583 8.27498 7.5375 9.77485C6.57917 11.2747 6.1 12.6066 6.1 13.7704C6.1 15.5735 6.66667 17.0459 7.8 18.1875C8.93333 19.3292 10.3333 19.9 12 19.9ZM12.35 18.9C12.55 18.8834 12.7208 18.8042 12.8625 18.6625C13.0042 18.5209 13.075 18.35 13.075 18.1501C13.075 17.9167 13 17.7292 12.85 17.5876C12.7 17.4459 12.5083 17.3834 12.275 17.4001C11.5917 17.45 10.8667 17.2625 10.1 16.8376C9.33333 16.4125 8.85 15.6417 8.65 14.5251C8.61667 14.3417 8.52917 14.1917 8.3875 14.0751C8.24583 13.9584 8.08333 13.9 7.9 13.9C7.66667 13.9 7.475 13.9875 7.325 14.1625C7.175 14.3375 7.125 14.5417 7.175 14.7751C7.45833 16.2917 8.125 17.375 9.175 18.025C10.225 18.675 11.2833 18.9667 12.35 18.9Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.092ecb4d36ed05bce472d51f5bd2447d.svg";
export { ForwardRef as ReactComponent };